<template>
  <div class="p-20">
    <app-filter :filter-list="table_filter" default-label-width="100px" @search="search" />
    <app-table
      ref="app_table_ref"
      class="mt-20"
      :table-key="table_key"
      :tablep="table_params"
      :get-data="getTaskAuthorVideoList"
      :table-props="{ 'max-height': '400px'}"
      :check="true"
      check-key="video_id"
      :is-reserve-checked="true"
      :is-row-click="true"
      @select-tr="selectionChange"
      @hook:mounted="onTableMounted"
    />
  </div>

</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { getTaskAuthorVideoListApi } from '@/api/tool/star-delivery';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'material-preview': () => import('@/views/auxiliary/material-library/components/material-preview'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 表单项配置 */
    formItem: {
      type: Object,
      required: true,
    },
    /** 广告主ID */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /**
     * 关联星广联投选项
     * - 启用: ON
     * - 不启用: OFF
     */
    starTaskSwitch: {
      type: String,
      required: true,
    },
    /** 关联星广联投 */
    starTasks: {
      type: Object,
      default: () => {},
    },
    /** 最大选取数量 - null代表不限制选取数量 */
    maxSelectionCount: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      /** 过滤项配置 */
      table_filter: require('./model/table-filter.js')(this),
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        page_size: 10,
      },
    };
  },
  created() {
    this.initFilterConfig();
  },
  methods: {
    /**
     * 初始化过滤配置
     * @returns {void}
     */
    initFilterConfig() {
      const { filter_config = {}} = this.formItem;
      if (!Object.keys(filter_config).length) {
        return;
      }

      Object.entries(filter_config).forEach(([key, value]) => {
        const filter_value = value[this.advertiserId];
        if (filter_value) {
          this.table_filter[key].value = filter_value;
          Object.assign(this.table_params, { [key]: filter_value });
        }
      });
    },
    /**
     * 获取初始化配置
     * @returns {Object}
     */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch (error){
        console.error(error);
        return {};
      }
    },
    /**
     * 搜索
     * @param {Object} params 过滤参数
     * @returns {void}
     */
    search(params = {}) {
      Object.assign(this.table_params, params);
      this.$refs['app_table_ref'].seekTable();

      const { video_publish_time } = this.table_params;
      const { filter_config_backup = {}} = this.formItem;
      if (!filter_config_backup.video_publish_time) {
        Object.assign(filter_config_backup, { video_publish_time: {}});
      }
      Object.assign(filter_config_backup.video_publish_time, { [this.advertiserId]: video_publish_time });
    },
    /**
     * 获取星广联投任务下达人视频列表接口
     * @param {Object} params 接口参数
     * @returns {Promise<Object>}
     */
    getTaskAuthorVideoList(params) {
      const { channel_interface } = this.getInitConfig();
      const { video_publish_time, ...rest } = params;
      const { aweme_setting_type, aweme_ids, exclude_aweme_ids } = this.formItem.api_params;
      const is_has_exclude_aweme_ids = Object.keys(exclude_aweme_ids).length;
      const is_has_aweme_ids = Object.keys(aweme_ids).length;
      return new Promise((resolve, reject) => {
        getTaskAuthorVideoListApi({
          channel_interface,
          advertiser_id: this.advertiserId,
          ...(this.starTasks?.[this.advertiserId]?.[0]?.id && {
            filtering: {
              star_task_id: this.starTasks[this.advertiserId][0].id,
              ...((aweme_setting_type === 'ALL' && is_has_exclude_aweme_ids && exclude_aweme_ids[this.advertiserId]?.length) && {
                exclude_aweme_ids: exclude_aweme_ids[this.advertiserId].map(({ id }) => id),
              }),
              ...((aweme_setting_type === 'MULTIPLE' && is_has_aweme_ids && aweme_ids[this.advertiserId]?.length) && {
                aweme_ids: aweme_ids[this.advertiserId].map(({ id }) => id),
              }),
              ...(video_publish_time?.length && { video_publish_start_date: video_publish_time[0], video_publish_end_date: video_publish_time[1] }),
            },
          }),
          ...rest,
        }).then(res => {
          res.list = (res?.list || []).map(item => Object.assign(item, { advertiser_id: this.advertiserId }));
          resolve({ ...res });
        }).catch(reject);
      });
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      this.initRowsSelection();
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      const app_table_ref = this.$refs.app_table_ref;
      const assign_selection = this.formItem.assignSelection[this.advertiserId] || [];
      app_table_ref.multipleSelection.splice(0);
      app_table_ref.multipleSelection.push(...assign_selection);
      app_table_ref.multipleSelectionAll.splice(0);
      app_table_ref.multipleSelectionAll.push(...assign_selection);
    },
    /**
     * 表格选择事件
     * @param {object} rows 表格数据
     */
    selectionChange(rows) {
      if (this.maxSelectionCount && rows?.length > this.maxSelectionCount) {
        this.$message.warning(`最大仅允许选中${this.maxSelectionCount}条数据`);
        this.resetTableSelection();
        return;
      }

      if (!this.formItem.assignSelection[this.advertiserId]) {
        this.formItem.assignSelection[this.advertiserId] = [];
      }
      const assign_selection = this.formItem.assignSelection[this.advertiserId];
      assign_selection.splice(0);
      assign_selection.push(...rows);
    },
    /**
     * 重置表格选中
     * @returns {void}
     */
    resetTableSelection() {
      const app_table_ref = this.$refs.app_table_ref;
      const assign_selection = this.formItem.assignSelection[this.advertiserId] || [];

      app_table_ref?.$refs?.table?.clearSelection?.();

      app_table_ref?.multipleSelection?.splice(0);
      app_table_ref?.multipleSelection?.push(...assign_selection);
      app_table_ref?.multipleSelectionAll?.splice(0);
      app_table_ref?.multipleSelectionAll?.push(...assign_selection);

      app_table_ref?.selectedPreExisting?.(assign_selection);
    },
  },
};
</script>
